import { post } from '@tencent/pmd-network';
import { getChildBasicInfo } from 'src/local-logic/tip-match/child-info';
import { getFirstTeam, getRankList, getTeamTotal } from 'src/local-logic/tip-match/team-info';
import { getBattleTotal } from 'src/local-logic/tip-match/battle-info';
import { QuestionType, UsualQuestions, Switch12 } from 'src/local-logic/utils/elimation-game.js';
import { parseGameParam } from './parse-game-param';
import { BattleRoomType, DEFAULT_GAME_PARAM_OPTIONS, GameParamMode } from 'src/local-logic/tip-match/create/game-param';
import { CreateGroupType } from 'src/local-logic/tip-match/create/split/groupType.js';
import { VsType, BpType, TeamMemRange } from 'src/local-logic/utils/team-mem-range.js';
import { getNextHourStart } from 'src/local-logic/tip-match/create/time.js';

export const RecommendStatus = {
  off: 50,
  on: 100,
  removed: 200,
};

/**
 * 获取赛事列表
 * @param options
 *  queryType 1进行中 2历史记录
 *  pageIdx pageidx
 *  num 默认为10
 */
export function getGameList(options) {
  return new Promise((resolve, reject) => {
    const reqData = {
      query_type: options.queryType || 0,
      page_idx: options.pageIdx || '',
      num: options.num || 10,
    };
    post({
      url: '/pvpesport.sgamenes.nesholder.nesholder/QueryPubGameList',
      reqData,
    }).then((response) => {
      const result = {
        gameList: [],
        pageIdx: '',
        isEnd: false,
      };
      if (response.game_list) {
        for (let i = 0; i < response.game_list.length; i++) {
          result.gameList.push(parsePubGameInfo(response.game_list[i]));
        }
      }
      if (response.page_idx) {
        result.pageIdx = response.page_idx;
      }
      result.isEnd = !result.pageIdx || result.pageIdx.length <= 0;
      resolve(result);
    })
      .catch((error) => {
        reject(error);
      });
  });
}
/**
 * 拉取赛事统计数据
 * @param options
 *          childId: 赛事id
 */
export function queryGameTotalDataReq(options) {
  const reqData = {
    child_id: Number(options.childId || 0),
  };
  return post({
    url: '/pvpesport.sgamenes.commcgi.commcgi/QueryGameTotalData',
    reqData,
  })
    .then(response => parseGameTotalData(response, options.battleMode));
}
/**
 * 拉取赛事信息
 * @param options
 *          childId: 赛事id
 *          withoutRule: 不需要赛事规则，默认false
 */
export function queryPubGameInfo(options) {
  return new Promise((resolve, reject) => {
    if (!options.childId) {
      return Promise.reject();
    }
    const reqData = {
      child_id: Number(options.childId || 0),
      without_rule: options.withoutRule || false,
    };
    post({
      url: '/pvpesport.sgamenes.nesholder.nesholder/QueryPubGameInfo',
      reqData,
    })
      .then((response) => {
        let result = {
        };
        if (response.r == 0) {
          result = parsePubGameInfo(response.game_info);
          result.templateCfg = parseTemplateCfg(response.pipline_cfg);
          result.extraInfo = parseExtraInfo(response.extra_info);
          // 当前阶段的状态， 0 未开始，10 阶段预览，20 阶段正在生成赛程中，30 阶段已生成赛程，100 阶段已开赛（只要有一个赛程开打），200  阶段结束（所有赛程全部打完）
          result.currentStageStatus = response?.stage_info?.status;
          result.originInfo = response;
        }
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const ApplyStatus = {
  0: '未申请',
  100: '审批中',
  300: '已通过',
  400: '已驳回',
};

export function queryGameInfo(reqData) {
  return post({
    url: '/pvpesport.sgamenes.nesholder.nesholder/QueryPubGameInfo',
    reqData,
  });
}

export const RecommendSwitch = {
  disable: 1,
  able: 2,
};

export function mapResRecommendConfig(config) {
  return {
    disableSearch: config?.disable_search ?? RecommendSwitch.able, // 1表示关闭
    disableRecommendLive: config?.disable_recommend_live ?? RecommendSwitch.able, // 1表示关闭
    principalRecommendStatus: config?.principal_recommend_status ?? RecommendStatus.off,
  };
}
export function mapReqRecommendConfig(config) {
  return {
    disable_search: config?.disableSearch ?? RecommendSwitch.able, // 1表示关闭
    disable_recommend_live: config?.disableRecommendLive ?? RecommendSwitch.able, // 1表示关闭
    principal_recommend_status: config?.principalRecommendStatus ?? RecommendStatus.off,
  };
}

export function mapCustomQuestion(questions = []) {
  // 身份证解析为姓名身份证号处理
  const idCardGroupIndex = (questions || []).findIndex(item => item.type === QuestionType.idCardGroup);
  const customQuestion = (questions || []).map((item) => {
    const { question, tips, require, type } = item;
    return {
      question,
      tips,
      require,
      type,
    };
  }) || [];
  const realNameIndex = (questions || []).findIndex(item => item.type === 'real_name');
  if (idCardGroupIndex > -1 && realNameIndex === -1) {
    customQuestion.splice(idCardGroupIndex, 1, {
      question: '姓名',
      require: true,
      tips: '请输入',
      type: 'real_name',
      disabled: true,
    }, {
      question: '身份证号',
      require: true,
      tips: '请输入',
      type: 'idcard',
      disabled: true,
    });
  }
  return customQuestion;
}

export function mapResCustomQuestion(enableQuestionnaire, questions = []) {
  // 为了兼容1.0.6.0之前的存量数据
  if (questions?.length === 0 && (enableQuestionnaire === 0 || enableQuestionnaire === undefined)) {
    const phoneQuestion = UsualQuestions.filter(item => item.type === QuestionType.phone) || [];
    return phoneQuestion;
  }
  return questions;
}

export function mapEnableQuesionnaire(enableQuestionnaire, needPhone) {
  // 为了兼容1.0.6.0之前的存量数据
  if (Number(needPhone) === Switch12.on && (enableQuestionnaire === 0 || enableQuestionnaire === undefined)) {
    return Switch12.on;
  }
  return enableQuestionnaire;
}

export function getVerify(matchRuleCfg) {
  return {
    enableVerify: matchRuleCfg.enable_auth !== 2, // 是否开启身份验证
    question: matchRuleCfg.enable_auth === 1 ? matchRuleCfg.authQA?.name : '',
    answer: matchRuleCfg.enable_auth === 1 ? matchRuleCfg.authQA?.value : '',
    authInviteCode: matchRuleCfg.auth_invite_code, // 邀请码批次号
    verifyMode: matchRuleCfg.enable_auth, // 报名身份验证方式 1:使用问题验证 2:关闭 3:使用邀请码验证
  };
}

export function parsePubGameInfo(gameInfo) {
  const res = {
    siteId: 0, // 主题站id
    parentId: 0, // 主活动id
    childId: 0, // 子活动id
    actStartTime: 0, // 比赛开始时间
    actEndTime: 0, // 比赛结束时间
    joinEnd: 0, // 报名结束时间
    gameName: '', // 赛事名称
    gameLogo: '', // 赛事logo
    gameTag: 0, // 赛事类型 1战队赛 2城市赛 3微赛事 4大区赛 5全国大赛 6大型合作赛事 7高校赛 8个人赛事（大众赛事）
    online: 0, // 是否线上赛 1线上赛 2线下赛（到场参赛）
    stage: 0, // 进程阶段 0,1 确认到场阶段 2,3 赛程阶段（循环赛只有2）4 赛程结束，确认名次发奖阶段 5 确认现金阶段
    gid: 331, // 游戏id
    rewardList: [], // 奖励列表
    ruleContent: '', // 规则内容
    ruleTitle: '', // 1默认规则 2自定义规则
    groupType: 0, // 赛制选择 3循环赛 4淘汰赛
    addressName: '', // 地址简称
    address: '', // 详细地址
    lat: 0.0, // 地址纬度
    lng: 0.0, // 地址经度
    utypeLimit: 0, // 0不限制 1只允许qq账号报名, 2只允许微信账号报名
    bgImg: '', // 背景图片
    gameStatus: 0, // 1 报名中, 2 待比赛, 3 比赛中, 4 已结束, 5 已下线
    isCoordinator: false, // 是否协管员
    creatorName: '', // 创建者昵称
    maxTeamNum: 0, // 最大队伍数
    boNum: 0, // bo类型
    bpType: 0, // bp类型
    modifyTeam: 1, // 允许进行中修改队名队徽
    creator: '', // 创建者id
    groupQrCode: '', // 群二维码
    status: 0, // 1未审核 2已通过 3已下线
    needPhone: 2, // 需要手机号
    teamMaxMem: 7, // 队伍最大人数
    teamMinMem: 7, // 队伍最小人数
    battleMode: 0, // 0表示5v5
    fightMode: 0, // 0 表示没有特殊模式
    liveAccount: {}, // 视频号
    scheduleStage: 0,
    teamRecruitType: 0, // 默认招募方式
    version: 0, // 编辑时透传给后端的version
    gameIntro: '', // 赛事简介
    verify: {},
    campConf: {}, // 阵营数据
    nicknameSwitch: false, // 昵称开关
    signUpConfirmSwitch: false, // 报名队伍需管理员确认
    globalBp: 0, // 全局Bp
    peakDuel: 0, // 巅峰对决
    customDefineId: 0, // 已选对局自定义参数类型
    battleCustomParams: [], // 对局自定义参数
    battleCustomParamsSetType: 1, // 对局自定义参数设置方式
    heroListStr: '', // 可选英雄数据
    playConf: {}, // 地图
  };
  const matchRuleCfg = gameInfo.match_rule_cfg || {};
  const externalPlatInfo = gameInfo.external_plat_infos || {};

  res.version = gameInfo?.version || 0;
  res.scheduleStage = gameInfo.schedule_stage || 0;
  res.siteId = gameInfo.site_id || 0;
  res.parentId = gameInfo.parent_id || 0;
  res.childId = gameInfo.child_id || 0;
  res.actStartTime = (gameInfo.act_start_time || 0) * 1000;
  res.actEndTime = (gameInfo.act_end_time || 0) * 1000;
  res.joinBegin = (gameInfo.join_begin || 0) * 1000;
  res.joinEnd = (gameInfo.join_end || 0) * 1000;
  res.gameName = gameInfo.game_name || '';
  res.gameLogo = gameInfo.game_logo || '';
  res.gameTag = gameInfo.game_tag || 0;
  res.online = gameInfo.online || 1;
  res.stage = gameInfo.stage || 0;
  res.gid = gameInfo.gid || 0;
  res.rewardList = parseRewardList(gameInfo.reward_list);
  res.ruleContent = parseRuleContent(gameInfo.rule_content);
  res.ruleTitle = gameInfo.rule_title || '';
  res.ruleType = Number(gameInfo.rule_title) || '';
  res.groupType = gameInfo.group_type || 0;
  res.addressName = gameInfo.address_name || '';
  res.address = gameInfo.address || '';
  res.lat = gameInfo.lat || 0.0;
  res.lng = gameInfo.lng || 0.0;
  res.city = gameInfo.city || '';
  res.province = gameInfo.province || '';
  res.nodeId = gameInfo.node_id || ''; // 组织id
  res.utypeLimit = matchRuleCfg.utype_limit || 0;
  res.teamMaxMem = matchRuleCfg.team_max_mem || 7;
  res.teamMinMem = TeamMemRange[matchRuleCfg.battle_mode || 0]?.min || 5,
  res.recommendConf = mapResRecommendConfig(gameInfo.match_rule_cfg?.recommend_conf);

  res.battleMode = matchRuleCfg.battle_mode || 0;
  res.fightMode = matchRuleCfg.custom_define_id || 0;
  res.bgImg = matchRuleCfg.background_pic || '';
  res.gameStatus = gameInfo.game_status || 0;
  res.creatorName = gameInfo.creator_name || '';
  res.isCoordinator = gameInfo.is_coordinator && gameInfo.is_coordinator == 1;
  res.maxTeamNum = (matchRuleCfg.max_team_num || 0) === 8192 ? 'NO_LIMIT' : matchRuleCfg.max_team_num;
  res.boNum = gameInfo.bo_num || 1;
  res.bpType = matchRuleCfg.bp_mode_new || 0;
  res.modifyTeam = matchRuleCfg.modify_team || 1;
  res.nicknameSwitch = matchRuleCfg.nicknameSwitch || false;
  res.signUpConfirmSwitch = getCommFieldsByKey(matchRuleCfg.comm_fields, 'signup_confirm') || 2;
  res.isOpenSignupGeo = getCommFieldsByKey(matchRuleCfg.comm_fields, 'enable_signin_geo_restrict') === '1';
  res.signInAddress = getCommFieldsByKey(matchRuleCfg.comm_fields, 'signin_geo_restrict_address') || '';
  res.signInLat = getCommFieldsByKey(matchRuleCfg.comm_fields, 'signin_geo_restrict_lat') || 0;
  res.signInLng = getCommFieldsByKey(matchRuleCfg.comm_fields, 'signin_geo_restrict_lng') || 0;
  res.creator = gameInfo.creator || '';
  res.groupQrCode = matchRuleCfg.chat_group_code_wx || '';
  res.status = matchRuleCfg.status || 0;
  res.autoEndJoinTag = matchRuleCfg.auto_end_join_tag || 0;
  res.virtualTag = matchRuleCfg.virtual_tag;
  res.teamRecruitType = matchRuleCfg.recruit_type || 0;
  res.brandLogoList = matchRuleCfg.brand_logo_list || [];
  res.match_rule_cfg = matchRuleCfg || [];
  res.needPhone = getCommFieldsByKey(matchRuleCfg.comm_fields, 'need_phone') || 2;
  res.liveAccount = parseLiveAccount(externalPlatInfo.length > 0 ? externalPlatInfo[0] : {});
  res.customQuestions = mapResCustomQuestion(matchRuleCfg.sign_up_questions_label, matchRuleCfg?.custom_questions);
  res.enableQuestionnaire = mapEnableQuesionnaire(matchRuleCfg.sign_up_questions_label, res.needPhone);
  res.aiCfgId = matchRuleCfg.ai_cfg_id || 1;
  res.gameIntro = getCommFieldsByKey(matchRuleCfg.comm_fields, 'game_introduction') || '';
  res.gameParam = parseGameParam(
    matchRuleCfg.custom_define_id,
    matchRuleCfg.battle_custom_params_set_type,
    matchRuleCfg.battle_custom_params,
  );
  res.enableOwnerskin = getCommFieldsByKey(matchRuleCfg.comm_integer_fields, 'has_bansheng_privilege') || 0;
  res.verify = getVerify(matchRuleCfg);
  const { enable, camp_infos: campInfos } = matchRuleCfg.camp_conf || {};
  res.campConf = {
    enable,
    campInfos,
  };
  res.globalBp = matchRuleCfg.global_bp || 0;
  res.peakDuel = matchRuleCfg.peak_duel || 0;
  res.battleCustomParams = matchRuleCfg.battle_custom_params || [];
  res.battleCustomParamsSetType = matchRuleCfg.battle_custom_params_set_type || 1;
  res.battleRoomType = matchRuleCfg.battle_room_type || BattleRoomType.BattleRoomDefault, // 房间类型
  res.customDefineId = matchRuleCfg.custom_define_id || 0;
  res.heroListStr = getCommFieldsByKey(matchRuleCfg.comm_fields, 'hero_list') || '';
  res.matchAuthStatus = getCommFieldsByKey(matchRuleCfg.comm_fields, 'match_auth_status') || 0;
  res.matchAuthId = getCommFieldsByKey(matchRuleCfg.comm_fields, 'match_auth_id') || '';
  res.matchAuthTime = getCommFieldsByKey(matchRuleCfg.comm_fields, 'match_auth_time') || '';
  res.level_limit = matchRuleCfg.level_limit || '';
  res.version = gameInfo.version || 0;
  res.customShowText = getCommFieldsByKey(matchRuleCfg.comm_fields, 'custom_show_text') || '';
  // 主理人权益-全部对局AI直播
  res.openAiLive = getCommFieldsByKey(matchRuleCfg.comm_fields, 'principal_benefits_aiLive') === 'true' || false;
  res.playConf = matchRuleCfg.play_conf || {};
  const metricListStr = getCommFieldsByKey(matchRuleCfg.comm_fields, 'calc_score_metric_list') || '';
  if (metricListStr) {
    try {
      res.metricList = JSON.parse(metricListStr) || [];
    } catch (e) {
      res.metricList = [];  // 解析失败时返回空数组
      console.error('metricListStr解析失败:', e);  // 记录错误日志
    }
  }
  res.applyType = matchRuleCfg.join_func; // 【1.2.9】支持单人匹配模式和匹配模式相关优化 - 整队匹配为默认模式
  return res;
}

export function parseGameTotalData(data, battleMode) {
  const result = {
    isShow: false, // tab是否显示
    list: [], // 统计数据列表
  };
  result.isShow = data.display === 1;
  const teamMinMemNum = `${battleMode || 5}`;
  result.list = [
    {
      title: '访问数据',
      dataList: [
        {
          num: data?.visit_total_data?.visit_total || 0,
          text: '赛事总访问·人',
        },
        {
          num: data?.visit_total_data?.visit_interview_total || 0,
          text: '赛事邀请函·人',
        },
        {
          num: data?.visit_total_data?.visit_team_interview_total || 0,
          text: '战队邀请函·人',
        },
      ],
    },
    {
      title: '报名数据',
      dataList: [
        {
          num: data?.signup_total_data?.sign_team_num || 0,
          text: '总报名·队',
        },
        {
          num: data?.signup_total_data?.full_team_num || 0,
          text: `满${teamMinMemNum}人·队`,
        },
        {
          num: data?.signup_total_data?.not_full_team_num || 0,
          text: `未满${teamMinMemNum}人·队`,
        },
        {
          num: data?.signup_total_data?.sign_mem_num || 0,
          text: '总报名·人',
        },
        {
          num: data?.signup_total_data?.full_mem_num || 0,
          text: `满${teamMinMemNum}人·人`,
        },
        {
          num: data?.signup_total_data?.not_full_mem_num || 0,
          text: `未满${teamMinMemNum}人·人`,
        },
      ],
    },
    {
      title: '比赛数据',
      dataList: [
        {
          num: data?.sch_battle_total_data?.end_sch_num || 0,
          text: '已结束·场',
        },
        {
          num: data?.sch_battle_total_data?.end_battle_num || 0,
          text: '已结束·局',
        },
        {
          num: data?.sch_battle_total_data?.battle_mem_num || 0,
          text: '参与对局·人次',
        },
        {
          num: data?.sch_battle_total_data?.battle_mem_uv || 0,
          text: '参与对局·人数',
        },
      ],
    },
    {
      title: '订阅数据',
      dataList: [
        {
          num: data?.subscrib_total_data?.s_game_num || 0,
          text: '赛事订阅·人',
        },
        {
          num: data?.subscrib_total_data?.s_team_num || 0,
          text: '战队订阅·人',
        },
        {
          num: data?.subscrib_total_data?.s_sch_num || 0,
          text: '比赛订阅·人',
        },
      ],
    },
    {
      title: '直播数据',
      dataList: [
        {
          num: data?.live_total_data?.live_battle_num || 0,
          text: '总开播·场',
        },
        {
          num: data?.live_total_data?.watch_mem_num || 0,
          text: '总观看·人次',
        },
        {
          num: data?.live_total_data?.battle_av_watch_num || 0,
          text: '场均观看·人次',
        },
        {
          num: data?.live_total_data?.battle_live_av_time || 0,
          text: '场均直播时长·分',
        },
        {
          num: data?.live_total_data?.watch_av_time || 0,
          text: '人均单场观看·分',
        },
      ],
    },
  ];
  return result;
}

export function parseLiveAccount(item) {
  const result = {
    channelId: '', // 视频号id
    avatar: '', // 头像
    name: '', // 名称
    openid: '', // 视频号主id
  };
  if (item) {
    result.channelId = item.external_id || '';
    result.name = item.name || '';
    result.avatar = item.header || '';
    result.openid = item.open_id || '';
  }
  return result;
}

export function getCommFieldsByKey(commFields, key) {
  if (commFields && commFields.length > 0) {
    const found = commFields.find(item => item.name == key);
    return found?.value;
  }
}

export function parseRewardList(rewardList) {
  if (!rewardList) {
    return [];
  }
  const list = [];
  for (let i = 0; i < rewardList.length; i++) {
    list.push(parseRewardItem(rewardList[i]));
  }
  return list;
}

export function parseRewardItem(reward) {
  const res = {
    id: '', // id
    title: '', // 奖励标题
    text: '', // 奖励描述 (大众赛事暂时不用)
    pic: '', // 奖励图片 (大众赛事暂时不用)
    itemList: [], // 奖励项目列表
    rewardType: 0,
    isChecked: false,
  };
  res.title = reward.title || '';
  res.text = reward.text || '';
  res.pic = reward.pic || '';
  res.id = reward.reward_id || '';
  res.rewardType = reward.reward_type || 0;
  res.isChecked = true;
  res.condition = getCondition(res.rewardType);
  res.itemList = parseRewardSubItemList(reward.item_list);
  return res;
}


function getCondition(rewardType) {
  for (const list of DEFAULT_CONDITION) {
    for (const item of list.typeList) {
      if (item.rewardType === rewardType) {
        return item;
      }
    }
  }
  return {};
}

export function parseRewardSubItemList(itemList) {
  if (!itemList) {
    return [];
  }
  const list = [];
  for (let i = 0; i < itemList.length; i++) {
    list.push(parseRewardSubItem(itemList[i]));
  }
  return list;
}

export function parseRewardSubItem(subItem) {
  const res = {
    itemText: '', // 单个奖励描述
    itemPic: '', // 单个奖励图片
  };
  res.itemText = subItem.item_text || '';
  res.itemPic = subItem.item_pic || '';
  res.itemNum = subItem.item_num || '';
  res.itemNumType = subItem.item_num_type || 1;
  res.propsPrice = (subItem.item_price || 0) / 100;
  res.propsId = subItem.item_id || 0;
  res.itemType = subItem.item_type || 0;
  res.payStatus = subItem.pay_status || 0;
  res.hasPay = subItem.pay_status == 1;
  res.gift_list = subItem.gift_list || [];
  res.itemStatus = subItem.asset_info?.status || 0;
  res.remaining = subItem.asset_info?.remaining || 0;
  res.asset_info = subItem.asset_info || {};
  return res;
}

/**
 * 拉取官方规则
 * @param options
 *  ruleId 规则id
 */
export function getRule(options) {
  return new Promise((resolve, reject) => {
    const reqData = {
      rule_id: options.ruleId,
    };
    post({
      url: '/pvpesport.sgamenes.nesholder.nesholder/QueryPubGameRule',
      reqData,
    }).then((response) => {
      const result = {
        itemList: [],
      };
      if (response.rule_content && response.rule_content.length > 0) {
        result.ruleContent = parseRuleContent(response.rule_content);
      }
      resolve(result);
    })
      .catch((error) => {
        reject(error);
      });
  });
}

export function parseRuleContent(rule) {
  if (!rule || rule.length <= 0) {
    return '';
  }
  let ruleContent = '';
  try {
    const itemList = JSON.parse(decodeURIComponent(rule));
    if (itemList && itemList.length > 0) {
      ruleContent = parseRuleItem(itemList[0]).content;
    }
  } catch (e) {
    console.log(`e: ${JSON.stringify(e)}`);
  }
  return ruleContent;
}

export function parseRuleItem(rule) {
  const res = {
    title: '',
    content: '',
  };
  res.title = rule.text1 || '';
  res.content = rule.text2 || '';
  return res;
}

export function queryMatchDetailInfo({ childId, qSrc }) {
  return new Promise((resolve, reject) => {
    if (!childId) {
      return reject(new Error(`childId is undefined, childId:${childId}`));
    }
    post({
      url: '/pvpesport.sgamenes.commcgi.commcgi/GetCommChildDetailPage',
      reqData: {
        child_id: childId,
        q_src: qSrc, //  1:管理员查询 2:参赛人员查询
      },
    }).then((res) => {
      if (res.r === 0) {
        const responseData = {};
        responseData.childInfo = getChildBasicInfo({
          childBasicInfo: res.child_desc,
          childProStatusInfo: res.child_pro_status,
        });
        responseData.totalTeamInfo = getTeamTotal({ teamTotal: res.team_total });
        responseData.totalBattleInfo = getBattleTotal({ battleTotal: res.battle_total });
        responseData.firstTeam = getFirstTeam({ firstTeam: res.first_team });
        responseData.rankList = getRankList({ rank: res.ranklist });
        responseData.isAdmin = res.is_admin || false;
        responseData.isViewer = res.q_src_type == 3;
        responseData.isPlayer = res.q_src_type == 2;
        responseData.roleList = res.role || [];
        responseData.currentRole = res.q_src_type || 0;
        responseData.liveInfo = res.live_info || {};
        responseData.hotSche = res.hot_sche || [];
        responseData.scheSubStatusMap = res.sche_sub_status || {};
        responseData.battleMode = res.child_desc.battle_mode;
        resolve(responseData);
        return;
      }
      reject(res);
    })
      .catch((err) => {
        reject(err);
      });
  });
}

export function queryTemplateCfg(childId) {
  return new Promise((resolve, reject) => {
    const reqData = {
      child_id: +childId,
    };
    post({
      url: '/pvpesport.sgamenes.nesholder.nesholder/QueryTemplateCfg',
      reqData,
    })
      .then((response) => {
        const result = {
          items: [],
          currTemplateCfg: {},
        };
        if (response.r == 0) {
          if (response.pipline_cfg_list) {
            for (let i = 0; i < response.pipline_cfg_list.length; i++) {
              result.items.push(parseTemplateCfg(response.pipline_cfg_list[i]));
            }
          }
          if (response.curr_template_cfg) {
            result.currTemplateCfg = parseTemplateCfg(response.curr_template_cfg);
          }
        }
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
// 附加字段
export function parseExtraInfo(item) {
  const result = {
    kvList: [], // KV图
    majorGameApplyInfo: {}, // 赛事录入申请
  };
  if (item) {
    result.kvList = item.kv_list || [];
  }
  if (item) {
    result.majorGameApplyInfo = item.major_game_apply_info || {};
  }
  return result;
}
export function parseTemplateCfg(item) {
  const result = {
    id: 0, // 模版id
    name: '', // 模版名称
    icon: '', // 模版名称
    type: 0, // 模式类型，100: 单淘 200: 循环赛 300: 杯赛 400: 自定义
    currStageNum: 0, // 当前阶段 从1开始
    modify: false, // 是否自定义过赛程
    stageCfgList: [], // 阶段列表
  };
  if (item) {
    const pExtraInfo = item.p_extra_info || {};
    const pStageInsSlice = item.p_stage_ins_slice || {};
    result.id = pExtraInfo.p_tpl_id || 0;
    result.name = pExtraInfo.p_tpl_name || '';
    result.icon = pExtraInfo.p_tpl_icon || '';
    result.type = pExtraInfo.p_mode_type || 0;
    result.currStageNum = item.curr_stage_num || 0;
    result.modify = pStageInsSlice.modify || false;
    if (item.game_stage_cfg_slice) {
      for (let i = 0; i < item.game_stage_cfg_slice.length; i++) {
        result.stageCfgList.push(parseStageCfgListItem(item.game_stage_cfg_slice[i]));
      }
    }
  }
  return result;
}

export function parseStageCfgListItem(item) {
  const result = {
    stageId: 0, // 按顺序填1，2，3
    stageName: '', // 阶段名称
    scheduleType: 0, // 赛制 （双败 单淘 循环）2 双败 3 循环赛 4 淘汰赛 （注意，这里无杯赛） 6 快速赛 8 匹配循环赛 8 匹配获胜赛回传时需要前端处理
    grpMemnum: 0, // 配置的多少人为一组 最多128
    grpPronum: 0, // 配置的多少人为一组 最多128
    cfgType: 0, // 配置类型
    grpNum: 0, // 循环赛需要的设置项
    cycleCount: 0, // 循环赛需要的设置项
    boNum: 0, // bo类型,
    bpType: 0, // bp类型
    matchConfId: '',
    matchTimeCfg: {},
    multiGroup: 0, // 淘汰赛受到分组标志, 1: 淘汰赛开启多分区
    customDefineId: 0,
    battleCustomParams: [],
    battleCustomParamsSetType: 0,
    enablePromotionCondition: false, // 是否匹配获胜赛
  };
  if (item) {
    result.stageId = item.stage_id || 0;
    result.stageName = item.stage_name || '';
    result.scheduleType = item.schedule_type || 0;
    result.scheduleText = getScheduleText(result.scheduleType);
    result.grpMemnum = item.grp_memnum || 0;
    result.grpPronum = item.grp_pronum || 0;
    result.cfgType = item.cfg_type || 0;
    result.grpNum = item.grp_num || 0;
    result.cycleCount = item.cycle_count || 0;
    result.boNum = item.bo_num || 0;
    result.bpType = item.bp_type || 0;
    result.matchConfId = item.match_conf_id || '';
    result.matchTimeCfg = getMatchTimeCfg(item);
    result.multiGroup = item.multi_group || 0;
    result.customDefineId = item.custom_define_id || 0;
    result.battleCustomParams = item.battle_custom_params || [],
    result.battleCustomParamsSetType = item.battle_custom_params_set_type || 0;
    result.eTime = item.e_time || 0;
    result.sTime = item.s_time || 0;
  }
  // 是否匹配获胜赛 匹配获胜赛需要设置 enablePromotionCondition 和 promotionCondition
  if (item.enable_promotion_condition) {
    result.enablePromotionCondition = item.enable_promotion_condition || false;
    result.promotionCondition = item.promotion_condition || {};
    result.sTime = item.s_time || getNextHourStart();
    result.eTime = item.e_time || getNextHourStart({ tomorrow: true });
  }
  if (Number(result.scheduleType) === 4) {
    result.branch3 = item.branch3 || 0; // 单败淘汰赛默认设置季军赛为关闭
  }
  return result;
}
function getMatchTimeCfg(item) {
  if (!item || !item.match_time_cfg) {
    return {};
  }
  const map = {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '日',
  };
  return {
    days: item.match_time_cfg.weekdays?.map(item => map[item]) || [],
    startAt: item.match_time_cfg.match_start_clock || '',
    endAt: item.match_time_cfg.match_end_clock || '',
  };
}

export function getScheduleText(type, multiGroup = false) {
  const map = {
    2: '双败淘汰赛',
    3: '循环赛',
    4: '单败淘汰赛',
    9: '瑞士轮',
    100: '分组单败淘汰赛',
    102: '分组双败淘汰赛',
    103: '分组瑞士轮',
    8: '匹配获胜赛',
  };
  if (multiGroup && type === 2) {
    return '分组双败淘汰赛';
  }
  if (multiGroup && type === 4) {
    return '分组单败淘汰赛';
  }
  if (multiGroup && type === 9) {
    return '分组瑞士轮';
  }
  if (map[type]) {
    return map[type];
  }
  return '未选择';
}

export function processTemplateStageList(template, status) {
  // 已开始的阶段不允许编辑
  if (template.currStageNum < 1) {
    return;
  }
  for (let i = 0; i < template.stageCfgList.length; i++) {
    if (i < template.currStageNum - 1 || (i == template.currStageNum - 1 && status >= 100)) {
      template.stageCfgList[i].disable = true;
    }
  }
}


export function addPubGameInfo(reqData) {
  return post({
    url: '/pvpesport.sgamenes.nesholder.nesholder/AddPubGameInfo',
    reqData,
  });
}
// 获取当前用户和赛事关系Req
export function getUserAndGameRel(reqData) {
  return post({
    url: '/pvpesport.sgamenes.nesholder.nesholder/GetUserAndGameRel',
    reqData,
  });
}
// 获取全部英雄数据
export function GetGameHeroCfg(reqData) {
  return new Promise((resolve, reject) => {
    post({
      url: '/pvpesport.sgamenes.nesplayer.nesplayer/GetGameHeroCfg',
      reqData,
    })
      .then((response) => {
        response.hero_list.forEach((v) => {
          v.EName = Number(v.EName);
        });
        response.hero_list.sort((a, b) => {
          if (a.EName < b.EName) return -1;
          if (a.EName > b.EName) return 1;
          return 0;
        });
        response.hero_list.forEach((v) => {
          v.EName = String(v.EName);
        });
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export const DEFAULT_CONDITION = [
  {
    title: '名次/参与奖',
    typeList: [
      {
        name: '冠军',
        desc: '	赛事冠军',
        isChecked: false,
        rewardType: 1,
      },
      {
        name: '亚军',
        desc: '	赛事亚军',
        isChecked: false,
        rewardType: 2,
      },
      {
        name: '季军',
        desc: '	赛事季军',
        isChecked: false,
        rewardType: 3,
      },
      {
        name: '4强',
        desc: '	赛事4强',
        isChecked: false,
        rewardType: 12,
      },
      {
        name: '8强',
        desc: '	赛事8强',
        isChecked: false,
        rewardType: 13,
      },
      {
        name: '参赛奖',
        desc: '	报名且上场1次',
        isChecked: false,
        rewardType: 5,
      },
      {
        name: '报名奖',
        desc: '	仅报名即可',
        isChecked: false,
        rewardType: 4,
      },
    ],
  },
  {
    title: '赛局表现奖',
    typeList: [
      {
        name: 'MVP奖',
        desc: '全赛事KDA榜第一名',
        isChecked: false,
        rewardType: 6,
      },
      {
        name: '超神奖',
        desc: '全赛事超神次数最多',
        isChecked: false,
        rewardType: 7,
      },
      {
        name: '经济最高奖',
        desc: '全赛事场均经济最高',
        isChecked: false,
        rewardType: 8,
      },
      {
        name: '伤害最高奖',
        desc: '全赛事场均伤害最高',
        isChecked: false,
        rewardType: 9,
      },
      {
        name: '击杀最多奖',
        desc: '总击杀数最高',
        isChecked: false,
        rewardType: 10,
      },
      {
        name: '阵亡最多奖',
        desc: '总死亡数最多',
        isChecked: false,
        rewardType: 11,
      },
    ],
  },
  {
    title: '自定义发奖',
    typeList: [
      {
        name: '自定义发奖',
        desc: '比赛结束后自行选择获奖队伍或玩家',
        isChecked: false,
        rewardType: 0,
      },
    ],
  },
];


export const DEFAULT_CONDITIONLIST = [
  {
    name: '冠军',
    rewardType: 1,
  },
  {
    name: '亚军',
    rewardType: 2,
  },
  {
    name: '季军',
    rewardType: 3,
  },
  {
    name: '4强',
    rewardType: 12,
  },
  {
    name: '8强',
    rewardType: 13,
  },
  {
    name: '参赛奖',
    rewardType: 5,
  },
  {
    name: '报名奖',
    rewardType: 4,
  },
  {
    name: 'MVP奖',
    rewardType: 6,
  },
  {
    name: '超神奖',
    rewardType: 7,
  },
  {
    name: '经济最高奖',
    rewardType: 8,
  },
  {
    name: '伤害最高奖',
    rewardType: 9,
  },
  {
    name: '击杀最多奖',
    rewardType: 10,
  },
  {
    name: '阵亡最多奖',
    rewardType: 11,
  },
];

export const DEFAULT_REWARD_LIST = [
  {
    title: '冠军',
    itemList: [{
      itemPic: '',
      itemNumType: 1,
      itemNum: 0,
    }],
    isDefault: true,
    isChecked: true,
    condition: {
      name: '冠军',
      rewardType: 1,
    },
  },
  {
    title: '亚军',
    itemList: [{
      itemPic: '',
      itemNumType: 1,
      itemNum: 0,
    }],
    isDefault: true,
    isChecked: true,
    condition: {
      name: '亚军',
      rewardType: 2,
    },
  },
  {
    title: '季军',
    itemList: [{
      itemPic: '',
      itemNumType: 1,
      itemNum: 0,
    }],
    isDefault: true,
    isChecked: true,
    condition: {
      name: '季军',
      rewardType: 3,
    },
  },
];

export const DEFAULT_REWARD_ITEM = {
  title: '',
  itemList: [],
  isNewReward: true,
  isChecked: true,
  condition: {
    name: '冠军',
    rewardType: 1,
  },
};

// 奖励数量限制
export const PrizeLimitNum = 50;

// 获取赛事玩法
export function GetGamePlayCfgs(reqData) {
  return new Promise((resolve, reject) => {
    post({
      url: '/pvpesport.sgamenes.nesgame.nesgame/GetGamePlayCfgs',
      reqData,
    })
      .then((response) => {
        let playCfgs = [];
        playCfgs = response?.play_cfgs?.map(v => ({
          id: v.id || 0,
          name: v.name || '',
          mapMode: v.map_id || MAP_TYPE.MapMode20111,
          simplifiedExplanation: v.simplified_explanation || '',
          recommend: v.recommend || false,
          priority: v.priority || 0,
          detailedExplanation: v.detailed_explanation || [],
          pic: v.pic || '',
          online: v.online || 0,
          battleMode: v.battle_mode || 0,
          entPlay: v.ent_play || 0,
        })) || [];

        sessionStorage.setItem('offlineType', JSON.stringify({
          id: 9999,
          name: '卡牌玩法',
          simplifiedExplanation: '线下玩法',
          detailedExplanation: ['地图：1v1', '局内数值：标准对局参数'],
          recommend: false,
          priorit: 999,
          online: 1,
          pic: 'https://igame-10037599.cos.ap-shanghai.myqcloud.com/pvpesportAdmin/1715765603279/match-type-bg4.png',
          mapMode: 20001,
          battleMode: 1,
          entPlay: 0,
        }));

        resolve(playCfgs);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const MAP_TYPE = {
  MapMode20011: 20011, // 0ban位娱乐模式
  MapMode20001: 20001, // 1v1房间
  MapMode20002: 20002, // 3v3房间
  MapMode20211: 20211, // 随机征召模式
  MapMode25004: 25004, // 召唤师峡谷1v1 对抗路
  MapMode25005: 25005, // 召唤师峡谷1v1 中路
  MapMode25006: 25006, // 召唤师峡谷1v1 发育路
  MapMode1012: 1012, // 5v5 快速赛
  MapMode20910: 20910, // 5v5 （0ban位）标准赛
  MapMode20911: 20911, // 5v5 （1ban位）标准赛
  MapMode20912: 20912, // 5v5 （2ban位）标准赛
  MapMode20913: 20913, // 5v5 （3ban位）标准赛
  MapMode20111: 20111, // 5v5 （4ban位）标准赛
  MapMode5121: 5121, // 5v5 觉醒之战
  MapMode90001: 90001, // 5v5 梦境大乱斗
  MapMode99988: 99988, // 10V10标准模式
  MapMpde4022: 4022, // 新2V2玩法
  MapMpde20017: 20017, // 无限乱斗
};
export const PLAY_ID = {
  norm2v2: 12, // 2V2标准模式
  norm3v3: 2, // 3v3标准模式
  norm5v5: 3, // 5v5标准模式
  custom5v5: 4, // 5v5自定义赛
  random5v5: 5, // 5v5随机抽卡
  paramBuff1: 6, // 5v5极速冷却
  paramBuff2: 7, // 5v5互秒荣耀
  paramBuff3: 9, // 5v5一步到位
  quick5v5: 10, // 5v5快速赛
  customSolo: 11, // 峡谷solo赛
  custom2v2: 13, // 2V2自定义模式
  norm1v1: 14, // 1v1标准模式
  paramBuff4: 15, // 5v5极限生存
  awakening: 17, // 觉醒之战
  dreamMelee: 18, // 梦境大乱斗
  norm10v10: 19, // 10V10标准模式
  new2v2: 20, // 新2V2玩法
  infiniteMelee: 21, // 无限乱斗
};
// 赛制
export const GROUP_TYPE = {
  quick: 6, // 快速赛
  elimination: 4, // 淘汰赛
  points: 3, // 积分赛
  cup: 5, // 杯赛
  doubleLose: 2, // 双败淘汰赛
  switzerland: 9, // 瑞士轮
  loop: 8, // 匹配循环赛
  custom: 7, // 5v5一步到位
  win: 10, // 匹配获胜赛 前端上传时需要将10转换为8
};
// 娱乐玩法列表 (觉醒之战,梦境大乱斗,无限乱斗)
export const ENTERTAINMENT_PLAY = [PLAY_ID.awakening, PLAY_ID.dreamMelee, PLAY_ID.infiniteMelee];
export const PLAY_ID_NAME = {
  [PLAY_ID.norm2v2]: ' 2V2标准模式',
  [PLAY_ID.norm3v3]: '3v3标准模式',
  [PLAY_ID.norm5v5]: '5v5标准模式',
  [PLAY_ID.custom5v5]: '5v5自定义赛',
  [PLAY_ID.random5v5]: '5v5随机抽卡',
  [PLAY_ID.paramBuff1]: '5v5极速冷却',
  [PLAY_ID.paramBuff2]: '5v5互秒荣耀',
  [PLAY_ID.paramBuff3]: '5v5一步到位',
  [PLAY_ID.quick5v5]: '5v5快速赛',
  [PLAY_ID.customSolo]: '峡谷solo赛',
  [PLAY_ID.custom2v2]: '2V2自定义模式',
  [PLAY_ID.norm1v1]: '1v1标准模式',
  [PLAY_ID.paramBuff4]: '5v5极限生存',
  [PLAY_ID.awakening]: '觉醒之战',
  [PLAY_ID.dreamMelee]: '梦境大乱斗',
  [PLAY_ID.norm10v10]: '10V10标准模式',
  [PLAY_ID.new2v2]: '	2v2最新模式',
  [PLAY_ID.infiniteMelee]: '无限乱斗',
};
export const QUICK_PLAY_ID = [
  PLAY_ID.norm1v1,
  PLAY_ID.norm3v3,
  PLAY_ID.norm5v5,
  PLAY_ID.custom5v5,
  PLAY_ID.random5v5,
  PLAY_ID.paramBuff1,
  PLAY_ID.paramBuff2,
  PLAY_ID.paramBuff3,
  PLAY_ID.paramBuff4,
];
export const GAME_PARAM_PLAY_ID = {
  [PLAY_ID.norm5v5]: DEFAULT_GAME_PARAM_OPTIONS.find(v => v.value === GameParamMode.GameParamModeStandard),
  [PLAY_ID.random5v5]: DEFAULT_GAME_PARAM_OPTIONS.find(v => v.value === GameParamMode.GameParamModeRandom),
  [PLAY_ID.custom5v5]: DEFAULT_GAME_PARAM_OPTIONS.find(v => v.value === GameParamMode.GameParamModeCustom),
  [PLAY_ID.paramBuff1]: DEFAULT_GAME_PARAM_OPTIONS.find(v => v.value === GameParamMode.GameParamModeCold),
  [PLAY_ID.paramBuff2]: DEFAULT_GAME_PARAM_OPTIONS.find(v => v.value === GameParamMode.GameParamModeSeckill),
  [PLAY_ID.paramBuff3]: DEFAULT_GAME_PARAM_OPTIONS.find(v => v.value === GameParamMode.GameParamModeMaxed),
  [PLAY_ID.paramBuff4]: DEFAULT_GAME_PARAM_OPTIONS.find(v => v.value === GameParamMode.GameParamModeSurvival),
};
export const GAME_MODE_TO_PLAY_ID_MAP = {
  [GameParamMode.GameParamModeCold]: PLAY_ID.paramBuff1,
  [GameParamMode.GameParamModeSeckill]: PLAY_ID.paramBuff2,
  [GameParamMode.GameParamModeMaxed]: PLAY_ID.paramBuff3,
  [GameParamMode.GameParamModeSurvival]: PLAY_ID.paramBuff4,
  [GameParamMode.GameParamModeStandard]: PLAY_ID.norm5v5,
  [GameParamMode.GameParamModeRandom]: PLAY_ID.random5v5,
  [GameParamMode.GameParamModeCustom]: PLAY_ID.custom5v5,
};
export const BP_MAPID = {
  [BpType.four]: MAP_TYPE.MapMode20111,
  [BpType.three]: MAP_TYPE.MapMode20913,
  [BpType.two]: MAP_TYPE.MapMode20912,
  [BpType.zero]: MAP_TYPE.MapMode20910,
};
export const VSTYPE_MAPID = {
  [VsType.five]: MAP_TYPE.MapMode20111,
  [VsType.three]: MAP_TYPE.MapMode20002,
  [VsType.solo]: MAP_TYPE.MapMode20001,
};
// 5v5娱乐玩法对应的 gameValue
export const PLAY_ID_PARAM_MODE = {
  [PLAY_ID.paramBuff1]: GameParamMode.GameParamModeCold,
  [PLAY_ID.paramBuff2]: GameParamMode.GameParamModeSeckill,
  [PLAY_ID.paramBuff3]: GameParamMode.GameParamModeMaxed,
  [PLAY_ID.paramBuff4]: GameParamMode.GameParamModeSurvival,
};

export const processRepeatedMatch = function (that) {
  const repeatedMatch = that.data?.templateCfg?.stageCfgList?.[0]?.scheduleType === CreateGroupType.repeatedMatch;
  if (that.isRepeatedMatch || repeatedMatch) {
    that.data.groupType = CreateGroupType.repeatedMatch;
    if (that.data.templateCfg?.stageCfgList?.length > 0) {
      that.data.repeatedMatch = that.data.templateCfg.stageCfgList[0].matchTimeCfg || {};
    }
    that.data.matchDeadLine = that.data.actEndTime;
  }
};
